import { render, staticRenderFns } from "./RoleFormModal.vue?vue&type=template&id=49fcc3d1&scoped=true"
import script from "./RoleFormModal.vue?vue&type=script&lang=js"
export * from "./RoleFormModal.vue?vue&type=script&lang=js"
import style0 from "./RoleFormModal.vue?vue&type=style&index=0&id=49fcc3d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fcc3d1",
  null
  
)

export default component.exports